<template>
  <b-button
    variant="warning"
    @click="update"
    class="mr-2"
  >

    <b-icon
      icon="arrow90deg-up" />
    更新
  </b-button>
</template>

<script>
export default {
  data () {
    return {
      modelName: 'user/seatingStatus'
    }
  },

  methods: {
    async update () {
      const result = await this.$store.dispatch(`${this.modelName}/update`)
      if (result) {
        this.$store.dispatch('toast/show', {
          content: 'メンバーのステータスを更新しました。',
          title: 'メンバーステータスの更新'
        })
        this.$router.back(-1)
      }
    }
  }
}
</script>
